<template>
    <div class="spacers">
        <div
            class="
                u-top-margin--xs
                u-left-margin--xs
                u-bottom-margin--xs
                u-right-margin--xs
                u-top-padding--xs
                u-left-padding--xs
                u-bottom-padding--xs
                u-right-padding--xs
            "
        >
            xs
        </div>
        <div
            class="
                u-top-margin--s
                u-left-margin--s
                u-bottom-margin--s
                u-right-margin--s
                u-top-padding--s
                u-left-padding--s
                u-bottom-padding--s
                u-right-padding--s
            "
        >
            s
        </div>
        <div
            class="
                u-top-margin--m
                u-left-margin--m
                u-bottom-margin--m
                u-right-margin--m
                u-top-padding--m
                u-left-padding--m
                u-bottom-padding--m
                u-right-padding--m
            "
        >
            m
        </div>
        <div
            class="
                u-top-margin--l
                u-left-margin--l
                u-bottom-margin--l
                u-right-margin--l
                u-top-padding--l
                u-left-padding--l
                u-bottom-padding--l
                u-right-padding--l
            "
        >
            l
        </div>
        <div
            class="
                u-top-margin--xl
                u-left-margin--xl
                u-bottom-margin--xl
                u-right-margin--xl
                u-top-padding--xl
                u-left-padding--xl
                u-bottom-padding--xl
                u-right-padding--xl
            "
        >
            xl
        </div>
        <div
            class="
                u-top-margin--xxl
                u-left-margin--xxl
                u-bottom-margin--xxl
                u-right-margin--xxl
                u-top-padding--xxl
                u-left-padding--xxl
                u-bottom-padding--xxl
                u-right-padding--xxl
            "
        >
            xxl
        </div>
        <div
            class="
                u-top-margin--xxxl
                u-left-margin--xxxl
                u-bottom-margin--xxxl
                u-right-margin--xxxl
                u-top-padding--xxxl
                u-left-padding--xxxl
                u-bottom-padding--xxxl
                u-right-padding--xxxl
            "
        >
            xxxl
        </div>
    </div>
</template>

<script>
export default {
    name: 'spacers'
}
</script>

<style lang="scss" scoped>
    .spacers {
        div {
            outline: 1px solid;
            background: #eee;
        }
    }
</style>
